<template>
	<div>
		<h1 class="heading">Головна</h1>
		<p>оберіть куди Ви хочете полетіти</p>
		<div class="underscore"></div>
		<a href="static/plan.html" class="menu__item bordered">
			<p style="color: #343637">План рахунків<br><span class="menu__item__description">бухгалтерського обліку</span>
			<img class="menu__item__arrow" src="https://litachok.mnau.edu.ua/home/static/img/right.svg">
			</p>
		</a>

		<a href="static/saldo.html" class="menu__item bordered">
			<p style="color: #343637">Розрахунок сальдо<br><span class="menu__item__description">з вибором виду рахунка</span>
			<img class="menu__item__arrow" src="https://litachok.mnau.edu.ua/home/static/img/right.svg">
			</p>
		</a>

		<a href="static/calculator.html" class="menu__item bordered">
			<p style="color: #343637">Калькулятори<br><span class="menu__item__description">зі зручним розрахунком</span>
			<img class="menu__item__arrow" src="https://litachok.mnau.edu.ua/home/static/img/right.svg">
			</p>
		</a>

		<a href="static/entry.html" class="menu__item bordered">
			<p style="color: #343637">Бухгалтерські проведення<br><span class="menu__item__description">за об'єктами обліку</span>
			<img class="menu__item__arrow" src="https://litachok.mnau.edu.ua/home/static/img/right.svg">
			</p>
		</a>

		<a href="static/accounts.html" class="menu__item bordered">
			<p style="color: #343637">Кореспонденція рахунків<br><span class="menu__item__description">зі зручним пошуком</span>
			<img class="menu__item__arrow" src="https://litachok.mnau.edu.ua/home/static/img/right.svg">
			</p>
		</a>

		<a href="static/figures.html" class="menu__item bordered">
			<p style="color: #343637">Важливі цифри<br><span class="menu__item__description">станом на вересень 2019 року</span>
			<img class="menu__item__arrow" src="https://litachok.mnau.edu.ua/home/static/img/right.svg">
			</p>
		</a>
		
		<a href="static/docs.html" class="menu__item bordered">
			<p style="color: #343637">Нормативна література<br><span class="menu__item__description">за об'єктами обліку</span>
			<img class="menu__item__arrow" src="https://litachok.mnau.edu.ua/home/static/img/right.svg">
			</p>
		</a>

		<a href="static/calendar.html" class="menu__item bordered2">
			<p class="menu__item_disabled">Професійний календар<br><span class="menu__item__description2">розділ в розробці</span>
			<img class="menu__item__arrow" src="https://litachok.mnau.edu.ua/home/static/img/right.svg">
			</p>
		</a>

		<a href="static/balance.html" class="menu__item bordered2">
			<p class="menu__item_disabled">Розрахунок балансу<br><span class="menu__item__description2">розділ в розробці</span>
			<img class="menu__item__arrow" src="https://litachok.mnau.edu.ua/home/static/img/right.svg">
			</p>
		</a>

		<div class="feed">
			<div class="feed_full">
				<p class="feed_title">Новини
					<span class="feed_title">
				<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="rss" class="svg-inline--fa fa-rss fa-w-14" role="img" width="25px" height="25px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="#EEC03A" d="M128.081 415.959c0 35.369-28.672 64.041-64.041 64.041S0 451.328 0 415.959s28.672-64.041 64.041-64.041 64.04 28.673 64.04 64.041zm175.66 47.25c-8.354-154.6-132.185-278.587-286.95-286.95C7.656 175.765 0 183.105 0 192.253v48.069c0 8.415 6.49 15.472 14.887 16.018 111.832 7.284 201.473 96.702 208.772 208.772.547 8.397 7.604 14.887 16.018 14.887h48.069c9.149.001 16.489-7.655 15.995-16.79zm144.249.288C439.596 229.677 251.465 40.445 16.503 32.01 7.473 31.686 0 38.981 0 48.016v48.068c0 8.625 6.835 15.645 15.453 15.999 191.179 7.839 344.627 161.316 352.465 352.465.353 8.618 7.373 15.453 15.999 15.453h48.068c9.034-.001 16.329-7.474 16.005-16.504z"></path>
				</svg>
				    </span>
				</p>
			</div>

			<div class="feed__container">
				<div class="feed__item" style="background-image: url(https://litachok.mnau.edu.ua/home/static/img/feed_bg1.svg)">
					<p class="feed__item__heading">Старт бета-тесту додатку</p>
						<p class="feed_time1" style="width: 75px;">17.09.19</p>
							<p class="feed__item__content">
								Наш літачок здійснює свій перший політ. Допоможіть нам покращити його <br>
								<br>
								Ми чекаємо фідбек від Вас
							</p>
				<a href="static/news.html">
					<div class="feed_time1" style="width: 100px; font-weight: lighter; padding: 4px">
						детальніше
					</div>
				</a>
				</div>
			</div>

			<!-- <div class="feed__container">
				<div class="feed__item" style="background-image: url(https://litachok.mnau.edu.ua/home/static/img/feed_bg4.svg)">
					<p class="feed__item__heading">Старт бета-тесту додатку</p>
						<p class="feed_time2" style="width: 75px;">02.08.19</p>
							<p class="feed__item__content">
								Наш літачок здійснює свій перший політ. Допоможіть нам покращити його <br>
								<br>
								Ми чекаємо фідбек від Вас
							</p>
				<a href="">
					<div class="feed_time2" style="width: 100px; font-weight: lighter; padding: 4px">
						детальніше
					</div>
				</a>
				</div>
			</div> -->
		</div>

		<app-plan v-show="planRahunkiv == '1'"></app-plan>

<div style="margin-bottom: 120px;"></div>

	</div>
</template>
<script>
export default {
	data () {
		return {
			planRahunkiv: '0',
			blockProvodok: '0',
			profCalendar: '0',
			normLiter: '0'
				}
			},
			mounted: function() {
				
			},
	methods: {

		}
	}
</script>
</script>
<style>
.heading {
    text-align: center;
    font-size:  26px;
    margin-top: 25px;
    margin-bottom: 15px;
    font-weight: bold;
}

.heading_news {
    text-align: center;
    font-size:  20px;
    margin-top: 25px;
    margin-bottom: 25px;
    font-weight: bold;
}

.feed__heading {
	font-weight: bold;
	font-size: 20px;
	text-align: center;
	color: #6d7173;
}
.bordered {
	background-color: #eee;
	padding: 1px 15px;
	border-bottom: solid 0px #eee;
	border-radius: 10px;
	transition: 0.4s;
	overflow: hidden;
	font-size: 14px;
	color: #2382DA;
	margin-top: 5px;
	font-weight: bold;
}

.active, .bordered:hover {
 	background-color: #E2E7FA; 
 	color: #283662;
}

.bordered2 {
	background-color: #eee;
	padding: 1px 15px;
	border-bottom: solid 0px #eee;
	border-radius: 10px;
	transition: 0.4s;
	overflow: hidden;
	font-size: 14px;
	color: #2382DA;
	margin-top: 5px;
	font-weight: bold;
	cursor: default;
}

/*.active, .bordered2:hover {
 	background-color: #E2E7FA; 
 	color: #283662;
}*/


.news_item {
	background-color: #2382DA;
	padding: 1px 15px;
	border-bottom: solid 1px #eee;
	border-radius: 10px;
	transition: 0.4s;
	overflow: hidden;
	font-size: 14px;
	color: #ffffff;
	margin-top: 5px;
}

.underscore {
	height: 4px;
	width: 50px;
	background-color: #EEC03A;
	margin: auto;
	margin-top: 10px;
	margin-bottom: 30px;
	border-radius: 2px;
}

h1 + p {
    text-align: center;
    color: grey;
    font-size: 16px;
    margin-top: -10px;
}

h2 + p {
    text-align: center;
    color: grey;
    font-size: 10px;
    margin-top: -10px;
}

.menu__item {
	display: -webkit-flex;
	display: -moz-flex;
	display: -ms-flex;
	display: -o-flex;
	display: flex;
	position: relative;
	font-size: 16px;
}

.menu__item > p {
	display: block;
	max-width: 85%;
}

.menu__item__description {
	color: #6d7173;
	font-size: 14px;
}


.menu__item__description2 {
	color: #abb0b3;
	font-size: 14px;
}

.feed_title {
	color: #000000;
	font-size: 20px;
	display: inline;
    position: relative;
    top: 5px;
    left: 0px;
    padding: 0px;
    height: 16px;
    width: 16px;
	}

.feed_full {
	text-align: center;
	margin-bottom: 20px;
	margin-top: 10px;
}

.menu__item__arrow {
	position: absolute;
	right: 10px;
	top: 35%;
}

.menu__item_disabled {
	color: #abb0b3;
}

.feed__container {
	display: -webkit-flex;
	display: -moz-flex;
	display: -ms-flex;
	display: -o-flex;
	display: flex;
	flex-direction: column;
}

.feed__item {
	position: relative;
	padding: 20px 20px 20px 20px;
	-webkit-background-size: cover;
	background-size: cover;
	color: #FFFFFF;
	display: flex;
	flex-direction: column;
	margin-bottom: 0px;
	background-color: #36406B;
	border-radius: 10px;
	margin-bottom: 10px;
}

.feed__item__heading {
	color: #FFFFFF;
	font-size: 20px;
	text-transform: uppercase;
	opacity: 1;
	transition: all .3s ease-out;
	margin-top: 0px;
	margin-bottom: 0px;
}

.feed_time1 {
    background-color: #EEEEEE;
    border-radius: 10px;
    padding-top: 2px;
    padding-bottom: 2px;
    padding-left: 2px;
    padding-right: 2px;
    color: #36406B;
    text-align: center;
    font-size: 14px;
}

.feed_time2 {
    background-color: #EEEEEE;
    border-radius: 10px;
    padding-top: 2px;
    padding-bottom: 2px;
    padding-left: 2px;
    padding-right: 2px;
    color: #B38705;
    text-align: center;
    font-size: 14px;
}

.feed__item__content {
	color: #FFFFFF;
	font-weight: 500;
	margin-top: 0px;
}

.feed__item__author {
	color: #fff;
	font-weight: 500;
	text-align: right;
	text-decoration: none;
	display: block;
	opacity: 1;
	transition: all .3s ease-out;
}

.feed_more {
	font-weight: 500;
	text-align: center;
	text-decoration: none;
	display: block;
	opacity: 1;
	transition: all .3s ease-out;
    background-color: #D7E0DF;
    border-radius: 10px;
    padding-top: 2px;
    padding-bottom: 2px;
    padding-left: 2px;
    padding-right: 2px;
    width: 100px;
    color: #36406B;
    font-size: 14px;
}

.feed_more:hover {
	opacity: 0.75;
}

.feed_more_svg {
	content: url(https://litachok.mnau.edu.ua/home/static/img/link.svg);
	margin-top: 0px;
	display: inline;
    position: relative;
}

@media screen and (min-width: 750px) {
.feed__container {
 	flex-direction: row;
 	justify-content: center;
 	flex-wrap: wrap;
}

.feed__item {
	margin: 0 10px 15px 0;
	/*height: 220px;*/
	width: 35%;
}
}
</style>
<style scoped>
	a {
		text-decoration: none;
		color: black;
	}
</style>


// WEBPACK FOOTER //
// src/mainMenu.vue